export default __webpack_public_path__ + "static/media/cake-1.5bcf91f0.jpg";